module.exports = __webpack_public_path__ + "img/xiaokeer.1dd25c83.jpg";